import { bindActionCreators } from 'redux'
import * as login from '../../../common/actions/login'
import * as language from '../../../common/actions/language'
import * as search from './search'
import * as propertyTypes from '../../../common/actions/classification/property_types'
import * as modal from '../../../common/actions/modal'

export default dispatch => ({
  login: bindActionCreators(login, dispatch),
  language: bindActionCreators(language, dispatch),
  search: bindActionCreators(search, dispatch),
  propertyTypes: bindActionCreators(propertyTypes, dispatch),
  modal: bindActionCreators(modal, dispatch)
})
